import useDataFetcher, { UseDataFetcherReturn } from 'Hooks/Http/useDataFetcher';
import VideoDetectionPlacement from 'Models/Videos/VideoDetectionPlacement';
import getVideoDetectionPlacements from 'Utils/Http/Requests/Videos/Placements/GetVideoDetectionPlacements';

const useFetchPlacements = (): UseDataFetcherReturn<VideoDetectionPlacement[]> =>
	useDataFetcher(getVideoDetectionPlacements);

export default useFetchPlacements;
